export { default as Costing } from './page'


// WEBPACK FOOTER //
// ./src/pages/Costing/index.js